export default __webpack_public_path__ + "static/GRID2022-Stock-Disasters-light-23a8f18452b33e59a21641534ac5d1d4.jpg";